import CNBTextArea from "./CNBTextArea";

export default CNBTextArea;
